import { atomWithSuspenseQuery } from 'jotai-tanstack-query';
import { User, UserDetails, UserNavOverrides } from '@statsbomb/parachute-types';
import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import { objSnakeToCamel } from '@/utils/queries';
import { fetchClientAtom } from './client';

export const userDetailsAtom = atomWithSuspenseQuery(get => {
  const queryKey = ['user'] as const;
  const queryFn = async () => {
    const { fetch } = get(fetchClientAtom);
    const response = await fetch(`/user-details`);
    return response as UserDetails;
  };
  return { queryKey, queryFn };
});

export const loadableUserDetailsAtom = loadable(userDetailsAtom);

const entityUsersAtom = atomWithSuspenseQuery(get => {
  const queryKey = ['entityUsers'] as const;
  const queryFn = async () => {
    const { fetch } = get(fetchClientAtom);
    const response = await fetch(`/entity/users`);
    return response as User[];
  };
  return { queryKey, queryFn };
});

export const identityProviderUserIdUserNameMapAtom = atom(async get => {
  const users = await get(entityUsersAtom);
  return users.data.reduce<Record<string, string>>((acc, user) => {
    acc[user.identity_provider_user_id] = user.name;
    return acc;
  }, {});
});

export const rawUserNavOverridesAtom = atomWithSuspenseQuery(get => {
  const queryKey = ['userNavOverrides'] as const;
  const queryFn = async () => {
    const { fetch } = get(fetchClientAtom);
    const response = await fetch(`/user/nav-overrides`);
    return response as UserNavOverrides;
  };

  return { queryKey, queryFn };
});

export const userNavOverridesAtom = atom(async get => {
  const userNavOverrides = await get(rawUserNavOverridesAtom);
  return objSnakeToCamel(userNavOverrides.data);
});
